var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-type-card"},[(_vm.srcImg)?_c('img',{staticClass:"order-type-card__ico",attrs:{"alt":"ico","src":_vm.srcImg}}):(_vm.text)?_c('div',{staticClass:"order-type-card__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }